import styles from "./Avatar.module.css";

/** Colours for avatars without a picture, picked by id so a person keeps theirs. */
const COLORS = ["#E8590C", "#0C8599", "#2B8A3E", "#AE3EC9", "#1971C2", "#C2255C", "#5F3DC4", "#E67700"];

export function colorFor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length]!;
}

export function Avatar({ id, name, src, size = 44, online = false, voxie = false }: { id: string; name: string; src?: string; size?: number; online?: boolean; voxie?: boolean }) {
  const letter = (name.trim()[0] ?? "?").toUpperCase();
  return (
    <span
      className={styles.avatar}
      style={{ width: size, height: size, fontSize: size * 0.4, background: voxie ? "linear-gradient(135deg, #5e01ce, #ff00a4)" : colorFor(id) }}
      aria-hidden
    >
      {src ? <img src={src} alt="" /> : letter}
      {online && <span className={styles.online} />}
    </span>
  );
}
